import { render } from "./HelloWorld.vue?vue&type=template&id=0fcf5a8c&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=0fcf5a8c&scoped=true&lang=css"

import exportComponent from "D:\\zhz\\projects\\bizspace\\wechatauthface\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcf5a8c"]])

export default __exports__